module.exports = __webpack_public_path__ + "static/media/ic_door_opened.289d5e68.png";